import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Header from './Header';

const navItems = [
  { path: '/', label: 'Dashboard', emoji: '📊', roles: ['super_admin','office_sales','field_sales'] },
  { path: '/customers', label: 'Musteriler', emoji: '👥', roles: ['super_admin','office_sales','field_sales'] },
  { path: '/deals', label: 'Firsatlar', emoji: '💼', roles: ['super_admin','office_sales','field_sales'] },
  { path: '/tasks', label: 'Gorevler', emoji: '✅', roles: ['super_admin','office_sales','field_sales'] },
  { path: '/users', label: 'Kullanicilar', emoji: '👤', roles: ['super_admin'] },
];
const roleColors = { super_admin:'bg-purple-100 text-purple-700', office_sales:'bg-blue-100 text-blue-700', field_sales:'bg-emerald-100 text-emerald-700' };
const roleLabels = { super_admin:'Super Admin', office_sales:'Ofis Satis', field_sales:'Saha Satis' };

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleLogout = () => { logout(); navigate('/login'); };
  const filtered = navItems.filter(i => i.roles.includes(user?.role));

  const Nav = () => (
    <div className="flex flex-col h-full">
      <div className="p-5 border-b border-slate-700/50">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 bg-indigo-500 rounded-xl flex items-center justify-center font-bold text-white shadow-lg text-lg">K</div>
          <div>
            <div className="font-bold text-white text-sm">Kanguroo CRM</div>
            <div className="text-slate-400 text-xs">v1.0</div>
          </div>
        </div>
      </div>
      <nav className="flex-1 p-4 space-y-1">
        <div className="text-slate-500 text-xs font-semibold uppercase tracking-wider px-3 mb-3">Menu</div>
        {filtered.map(item => {
          const active = location.pathname === item.path;
          return (
            <Link key={item.path} to={item.path} onClick={() => setMobileOpen(false)}
              className={"sidebar-link " + (active ? 'bg-indigo-600 text-white shadow-sm' : 'text-slate-400 hover:bg-slate-700/50 hover:text-white')}>
              <span>{item.emoji}</span>
              <span>{item.label}</span>
              {active && <div className="ml-auto w-1.5 h-1.5 rounded-full bg-white opacity-70" />}
            </Link>
          );
        })}
      </nav>
      <div className="p-4 border-t border-slate-700/50">
        <div className="flex items-center gap-3 px-3 py-2.5 rounded-xl bg-slate-700/40">
          <div className="w-8 h-8 rounded-lg bg-indigo-500 flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
            {user?.full_name?.[0]?.toUpperCase() || 'U'}
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-white text-xs font-semibold truncate">{user?.full_name}</div>
            <span className={"text-xs px-1.5 py-0.5 rounded mt-0.5 inline-block " + roleColors[user?.role]}>{roleLabels[user?.role]}</span>
          </div>
          <button onClick={handleLogout} className="text-slate-400 hover:text-red-400 transition-colors">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="flex h-screen overflow-hidden">
      <aside className="hidden md:flex w-60 bg-slate-800 flex-col flex-shrink-0 shadow-xl"><Nav /></aside>
      {mobileOpen && (
        <div className="fixed inset-0 z-50 md:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setMobileOpen(false)} />
          <aside className="relative w-60 bg-slate-800 h-full flex flex-col shadow-2xl"><Nav /></aside>
        </div>
      )}
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="bg-white border-b border-gray-100 px-4 py-3 flex items-center gap-3 md:hidden">
          <button onClick={() => setMobileOpen(true)} className="p-2 rounded-lg hover:bg-gray-100">
            <svg className="w-5 h-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16"/>
            </svg>
          </button>
          <span className="font-bold text-gray-800">🦘 Kanguroo CRM</span>
        </header>
        <Header />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 bg-gray-50 animate-fadein">{children}</main>
      </div>
    </div>
  );
}
